module.exports = __webpack_public_path__ + "images/fa-about-us-2.jpg";